import React, { Component } from 'react';
import { soundManager } from 'soundmanager2';
import ReactSlider from 'react-slider';
import './PlayerControls.css';
import Timer from './Timer';
import swal from 'sweetalert';

const mp3_stream = 'http://stream.customchannels.net/floyds_96.mp3';

class PlayerControls extends Component {

    constructor(props){
        super(props);
        this.state = {
            playing: false,
            volume: 50
        };
    }

    componentWillMount(){
        var self = this;
        soundManager.setup({
            debugMode: false,
            onready: function(){
                self.stream = soundManager.createSound({
                    autoLoad: true,
                    volume: self.state.volume,
                    stream: true,
                    id: 'stream',
                    url: mp3_stream
                });
            }
        });

        this.createTimer();
    }

    playPause(){
        if(!this.state.playing){
            this.stream.play();
            this.Timer.startTimer();
            this.setState({ playing: true });
        }else{
            this.stream.stop();
            this.Timer.stopTimer();
            this.setState({ playing: false });
        }
    }

    // create 2 timers
    // first timer shows a warning
    // second timer shuts off the music
    createTimer(){

      // create the main timer for 120 minutes
      const self = this;
      this.Timer = new Timer(120);
      this.Timer.on('end', function(){

          // give the user 10 minutes to respond 
          // and then shut off music
          const Timer2 = new Timer(10);
          Timer2.startTimer();
          Timer2.on('end', function(){
            // stop the player
            self.stream.stop();
            self.setState({ playing: false });
          });

          swal({
            title: "Are you still there?",
            icon: "info",
            text: "The music will pause in 10 minutes.  You can keep it going by clicking the button below.",
            button: 'Yup! Still Listening!'
          }).then((value) => {
              self.Timer.startTimer();
              Timer2.stopTimer();
          });
      });
    }

    changeVolume(e){
        let volume = e[1];
        this.stream.setVolume(volume);
        this.setState({ volume: volume });
    }

    render() {
        return (
            <div className="PlayerControls">
                <a onClick={ this.playPause.bind(this) } id="play-pause"><i className={ !this.state.playing ? "fa fa-play fa-4x" : "fa fa-pause fa-4x" }></i></a>
                <ReactSlider className="volume-slider" defaultValue={ [0, this.state.volume, 100] } onChange={ this.changeVolume.bind(this) } withBars>
                    <div className="volume-down"><i className="fa fa-2x fa-volume-down"></i></div>
                    <div className="toggle"></div>
                    <div className="volume-up"><i className="fa fa-2x fa-volume-up"></i></div>
                </ReactSlider>
            </div>
        );
    }
}

export default PlayerControls;



// WEBPACK FOOTER //
// ./src/PlayerControls.js